<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      v-if="showTable"
      :headers="headers"
      :get-data-func="getPassLogs"
      no-data-text="没有通行记录"
      title-text="通行日志"
      clickable
      :init-pagination="{ sortBy: 'passDatetime', descending: true }"
      :filterItems="filterItems"
      @click:row="goDetails"
    >
      <template slot="title">
        <span class="pl-2 pr-4">行人通行日志</span>
        <v-btn flat color="primary" @click="$router.push({name: 'PersonPassStatistics'})">预约行人统计</v-btn>
        <v-btn flat color="primary" :loading="loading" @click="outputExcel_2"
          >导出excel</v-btn
        >
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
import { time } from "../../../ladmin/utils";
import LSelectController from "../../../components/LSelectController";
import LSelectDatetimeDuration from "../../../ladmin/components/LSelectDuration/LSelectDatetimeDuration";
function passTypeMap(v) {
  switch (v) {
    case "ECARD":
      return "一卡通";
    case "QRCODE":
      return "二维码刷码";
    case "QRCHECK":
      return "扫码";
    case "SELF_ORDER":
      return "自助预约";
    default:
      return "N/A";
  }
}
export default {
  name: "PersonPassLogList",
  components: { LSelectDatetimeDuration },
  data: () => ({
    showTable: true,
    loading: false,
    amount: 0,
    headers: [
      { text: "姓名", value: "name", placeholder: "N/A" },
      { text: "预约人", value: "applicantName", placeholder: "N/A", sortable: false },
      { text: "预约人二级单位", value: "applicantOrgName", placeholder: "N/A", sortable: false },
      { text: "个人/单位预约", value: "passRuleType", sortable: false,
        f: v => v === "order_object" ? "个人预约" : v === "order_group" ? "单位预约" : "N/A" },
      { text: "手机号", value: "phone", placeholder: "N/A" },
      {
        text: "工号/学号",
        value: "loginId",

        placeholder: "N/A",
      },
      {
        text: "登记类型",
        value: "userType",

        placeholder: "N/A",
      },
      { text: "单位", value: "org", placeholder: "N/A" },
      { text: "物理卡号", value: "ecardId", placeholder: "N/A" },
      {
        text: "通行时间",
        value: "passDatetime",

        placeholder: "N/A",
      },
      {
        text: "通行类型",
        value: "passType",

        f: (v) => passTypeMap(v),
        placeholder: "N/A",
      },
      {
        text: "通行校区",
        value: "parkingLotName",

        placeholder: "N/A",
        sortable: false,
      },
      {
        text: "通行关口",
        value: "controllerName",

        placeholder: "N/A",
        sortable: false,
      },
      {
        text: "是否放行",
        value: "status",

        placeholder: "N/A",
        f: (v) => (v + "" === "1" ? "抬杆放行" : "禁止通行"),
      },
      {
        text: "备注",
        value: "details",

        placeholder: "N/A",
        tooltip: true,
        maxWidth: "14em",
      },
    ],
    filterItems: [
      {
        label: "是否放行",
        layout: ["xs12", "sm4"],
        type: "select",
        key: "status",
        value: "",
        items: [
          { text: "抬杆放行", value: "1" },
          { text: "禁止通行", value: "0" },
        ],
      },
      {
        label: "姓名",
        layout: ["xs12", "sm4"],
        type: "input",
        key: "name",
        value: "",
      },
      {
        label: "学号/工号",
        layout: ["xs12", "sm4"],
        type: "input",
        key: "loginId",
        value: "",
      },
      {
        label: "手机号",
        layout: ["xs12", "sm4"],
        type: "input",
        key: "phone",
        value: "",
      },
      {
        label: "通行类型",
        layout: ["xs12", "sm4"],
        type: "select",
        key: "passType",
        value: "",
        items: [
          { text: "一卡通", value: "ECARD" },
          { text: "二维码刷码", value: "QRCODE" },
          { text: "扫码", value: "QRCHECK" },
            { text: "自助预约", value: "SELF_ORDER" },
        ],
      },
      {
        label: "通行时间",
        layout: "xs12, sm8",
        type: "duration",
        key: "creationTime",
        value: {},
        range: true,
        f: (v) => {
          if (!v.startDatetime && !v.endDatetime) {
            return null;
          } else {
            let s = time.toTimeStamp(v.startDatetime) || 0;
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999;
            return [s, e];
          }
        },
      },
      {
        key: "controllerId",
        value: [],
        component: LSelectController,
        passType: "person",
        f: (v) => {
          console.log(
            [].concat(...v.map((g) => g.controllers.map((c) => c.id)))
          );
          return [].concat(...v.map((g) => g.controllers.map((c) => c.id)));
        },
      },
    ],
    optionData: {
      color: ["#3398DB"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      xAxis: {
        type: "category",
        data: [],
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "通行量",
          data: [],
          type: "bar",
        },
      ],
    },
    selectData: [],
  }),
  methods: {
    async outputExcel_2() {
      const period = this.filterItems.find(item => item.key === "creationTime").value || {};
      const start = time.toTimeStamp(period.startDatetime);
      const end = time.toTimeStamp(period.endDatetime);
      if (!start || !end || end <= start || end - start > 93 * 24 * 60 * 60 * 1000) {
        this.$L.alert("error", { message: "请选择不超过93天的通行时间段" });
        return;
      }
      this.loading = true;
      try {
        const rows = [];
        const size = 100;
        for (let page = 1; ; page++) {
          const res = await this.$store.dispatch("personPassControl/getLogs", {
            pagination: { page, rowsPerPage: size, sortBy: "passDatetime", descending: true },
            filter: this.filterItems,
          });
          rows.push(...res.items);
          if (page * size >= res.amount || !res.items.length) break;
        }
        if (!rows.length) {
          this.$L.alert("error", { message: "当前筛选条件下没有可导出的通行记录" });
          return;
        }
        const ExportJsonExcel = require("js-export-excel");
        new ExportJsonExcel({
          fileName: "行人通行日志",
          datas: [{
            sheetName: "通行日志",
            sheetHeader: [
              "姓名", "预约人", "预约人二级单位", "个人/单位预约", "联系电话",
              "学号/工号", "登记类型", "单位", "物理卡号", "通行时间", "通行类型",
              "通行校区", "通行卡口", "是否放行", "备注",
            ],
            sheetData: rows.map(item => [
              item.name, item.applicantName, item.applicantOrgName,
              item.passRuleType === "order_object" ? "个人预约" :
                item.passRuleType === "order_group" ? "单位预约" : "",
              item.phone, item.loginId, item.userType, item.org, item.ecardId,
              item.passDatetime, passTypeMap(item.passType), item.parkingLotName,
              item.controllerName, String(item.status) === "1" ? "抬杆放行" : "禁止通行",
              item.remark,
            ]),
          }],
        }).saveExcel();
      } catch (error) {
        this.$L.alert("error", { message: "导出失败：" + error.message });
      } finally {
        this.loading = false;
      }
    },
    async getPassLogs({ pagination, sortStack, filterItems, search }) {
      const res = await this.$store.dispatch("personPassControl/getLogs", {
        pagination,
        sortStack,
        filter: filterItems,
        search: { key: "plate", value: search },
      });
      this.amount = res.amount;
      return res;
    },
    goDetails({ item }) {
      let selectionString = document.getSelection().toString();
      if (!selectionString) {
        this.$router.push({
          name: "PersonStatisticDetails",
          params: { plate: item.plate },
          query: { id: item.id, plate: item.plate },
        });
      }
    },
    async drawCharts() {
      if (this.filterItems[1].value.startDatetime === undefined) {
        this.$L.alert("error", { message: "添加时间段不能为空" });
        return;
      }
      // console.log(this.filterItems[1].value)
      this.loading = true;
      let res = await this.$store.dispatch("pass/getLogs", {
        pagination: {},
        filter: this.filterItems,
      });
      this.loading = false;
      this.optionData.xAxis.data.push(
        this.filterItems[1].value.startDatetime +
          "至" +
          this.filterItems[1].value.endDatetime
      );
      this.optionData.series[0].data.push(res.amount);
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption(this.optionData);
    },
  },
};
</script>

<style scoped>
</style>
